export const MAX_CONCURRENT_UPLOADS: number = 5;

export const ResourceTypes = {
  IMAGE: 'image',
  PDF: 'pdf',
  VIDEO: 'video',
};

export const getResourceTypeLabelPlural = (type: string) => {
  switch (type) {
    case ResourceTypes.IMAGE:
      return 'Images';
    case ResourceTypes.PDF:
      return 'PDF';
    case ResourceTypes.VIDEO:
      return 'Vidéos';
    default:
      console.warn(`Unknown resource type ${type}`);
      return 'Autres';
  }
};



// WEBPACK FOOTER //
// ./src/modules/bucket/constants/index.js